export const FEATURE_PAGE_FAMILIES = ["genre", "style", "collection", "story"] as const;
export const FEATURE_PAGE_TAXONOMY_FAMILIES = ["genre", "style"] as const;
export type FeaturePageFamily = (typeof FEATURE_PAGE_FAMILIES)[number];

export const FEATURE_PAGE_PATHS = {
  genre: "/genres",
  style: "/styles",
  collection: "/collections",
  story: "/stories",
} as const satisfies Record<(typeof FEATURE_PAGE_FAMILIES)[number], string>;
